import LeadsField from './LeadsField.component';

export default LeadsField;
